export default __webpack_public_path__ + "static/media/PinkFrame03.5174eed7.png";